import { useSelector } from 'react-redux';
import BaseTable from '../../components/BaseTable';
import { fetchTransactionsListOrEmpty } from '../../api/careRecords';
import { CARE_TABLE_KIND, useTableColumns } from '../../hooks/columns';
import { useCareList } from '../../hooks/useCareList';

export default function Transactions() {
  const token = useSelector((state) => state.auth.token);
  const columns = useTableColumns(CARE_TABLE_KIND.transactions);
  const { data, loading, error } = useCareList(
    fetchTransactionsListOrEmpty,
    token
  );

  return (
    <div className="care-page">
      <BaseTable
        columns={columns}
        dataSource={data}
        loading={loading}
        error={error}
        searchKeys={[
          'id',
          'patientName',
          'doctorName',
          'patientEmail',
          'status',
          'kind',
          'amountText'
        ]}
        searchPlaceholder="Search id, patient, doctor, amount, kind, status…"
        emptyText="No transactions found."
      />
    </div>
  );
}
